import { StrictMode } from 'react';
import './i18n';
import { hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// プリレンダされたHTMLを React が引き継ぐ（ハイドレーション）
hydrateRoot(
  document.getElementById('root')!,
  <StrictMode>
    <App />
  </StrictMode>,
);
